import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-159">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-160" />
      <div className="relative bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl" data-id="element-161">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800" data-id="element-162">
          <h2 className="text-lg font-bold text-white" data-id="element-163">{title}</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition-colors" aria-label="Cerrar" data-id="element-164">
            <X className="w-5 h-5" data-id="element-165" />
          </button>
        </div>
        <div className="px-6 py-6 overflow-y-auto text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-166">
          {children}
        </div>
      </div>
    </div>;
}